// extracted by mini-css-extract-plugin
export default {"mobile-max-px":"699","mobileMaxPx":"699","tablet-max-px":"1199","tabletMaxPx":"1199","desktop-max-px":"1599","desktopMaxPx":"1599"};